import { getContentFields } from '@eliadmin/core/src/api/content-fields/public-content-fields';
import { ContentFieldBlock } from '@eliadmin/core/src/components/content-fields/content-fields';
import type { TravelAgencyTour } from '@eliadmin/core/src/api/travel-agency/travel-agency-api';

import { TourTabHeading } from '../tour-content';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { TourBlogs } from '../../tour-blogs';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

export function ProgramTab({ tour }: { tour: TravelAgencyTour }) {
  const locale = useLocaleStore(s => s.currentLocale);
  const program = getContentFields(tour).find(group => group.id === 1);

  return (
    <div className="flex w-full flex-col items-start justify-start gap-6 lg:gap-8">
      <TourTabHeading title="Program" />
      <div className={cn('w-full', 'ea-tour__description-tab-content', 'ea-tour__program-content')}>
        {program && <ContentFieldBlock field={program} module="tours" showTitle={false} />}
      </div>
      {tour.id === 11 && <TourBlogs locale={locale} />}
    </div>
  );
}
